<ion-content class="triangle-background">
  <div class="flex flex-col items-center mt-10 gap-40">
    <ion-icon *ngIf="success" class="w-64 h-64" name="gt-check-green"></ion-icon>
    <ion-icon *ngIf="!success" class="w-64 h-64" name="gt-wrong-payment"></ion-icon>
    <div class="flex flex-col items-center gap-4">
      <h2 class="text-center">
        {{(success ? 'CHECKOUT.PAYMENT_RESPONSE.TITLE_OK': 'CHECKOUT.PAYMENT_RESPONSE.TITLE_KO') | transloco}}
      </h2>
      <div class="text-center">{{(success ? 'CHECKOUT.PAYMENT_RESPONSE.DESC_OK': 'CHECKOUT.PAYMENT_RESPONSE.DESC_KO') | transloco}}</div>
      <gt-button *ngIf="success" routerLink="/home">{{'COMMON.ACCEPT' | transloco}}</gt-button>
      <gt-button *ngIf="!success" routerLink="/home">{{'CHECKOUT.PAYMENT_RESPONSE.BUTTON_KO' | transloco}}</gt-button>
    </div>
  </div>
</ion-content>
